import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const GiftCards = Loadable(lazy(() => import('./giftCards')));

const giftCardRoutes = [
  { path: '/dashboard/gift-cards', element: <GiftCards />, auth: authRoles.admin },
];

export default giftCardRoutes;
